module.exports = __webpack_public_path__ + "static/New-ba0988f0da4f1adf25863036f2c7d580.png";